import { jsx } from "react/jsx-runtime";
import { useMemo, createContext, useContext } from "react";
import { useStudioVoiceBranding, useThemeColors } from "@brandclub/bc-widgets";
/* empty css                 */
const VoiceThemeContext = createContext({
  persona: { assistantName: "Benny" },
  visual: {}
});
const useVoiceThemeContext = () => useContext(VoiceThemeContext);
function buildCssVars(brandColors) {
  const vars = {};
  if (brandColors.textPrimary) {
    vars["--voice-widget-fg"] = brandColors.textPrimary;
    vars["--voice-widget-price"] = brandColors.textPrimary;
  }
  if (brandColors.primary) {
    vars["--voice-widget-button-bg"] = brandColors.primary;
    vars["--voice-widget-accent"] = brandColors.primary;
    vars["--voice-widget-accent-dark"] = brandColors.primary;
  }
  if (brandColors.buttonText) {
    vars["--voice-widget-button-fg"] = brandColors.buttonText;
  }
  return vars;
}
const VoiceThemeProvider = ({
  children,
  overrides
}) => {
  const persisted = useStudioVoiceBranding();
  const { themeColors } = useThemeColors();
  const merged = useMemo(() => {
    var _a, _b;
    if (!overrides) return persisted;
    return {
      persona: { ...persisted.persona, ...overrides.persona },
      visual: {
        blobStyle: ((_a = overrides.visual) == null ? void 0 : _a.blobStyle) ?? ((_b = persisted.visual) == null ? void 0 : _b.blobStyle)
      }
    };
  }, [persisted, overrides]);
  const cssVars = useMemo(() => buildCssVars(themeColors), [themeColors]);
  const ctxValue = useMemo(
    () => ({ persona: merged.persona, visual: merged.visual ?? {} }),
    [merged.persona, merged.visual]
  );
  return /* @__PURE__ */ jsx(VoiceThemeContext.Provider, { value: ctxValue, children: /* @__PURE__ */ jsx("div", { style: { display: "contents", ...cssVars }, children }) });
};
export {
  VoiceThemeProvider,
  useVoiceThemeContext
};
//# sourceMappingURL=VoiceThemeProvider.js.map
